import router from "@/router";
import axios from "axios";
import { Message } from "element-ui";

const getFinalPathFromHash = () => {
  // 首先获取URL中的哈希部
  const url = window.location.href;
  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) {
    return ""; // 如果没有哈希部分，返回空字符串
  }
  const hash = url.substring(hashIndex + 1); // 从哈希开始截取字符串
  // 然后使用split方法按 '/' 分割哈希部分
  const parts = hash.split("/");
  // 获取分割后的最后一个元素
  const finalPath = parts.pop() || "";
  return finalPath;
};
const request = (url, method, data, base) => {
  let baseUrl = base ? base : process.env.VUE_APP_BASE_API;
  let token = localStorage.getItem(
    "user_token_" + localStorage.getItem(getFinalPathFromHash() + "c_id")
  );
  var header = {
    Token: token != null ? token : "",
    Encrypt: getFinalPathFromHash(),
    Code: getFinalPathFromHash(),
  };
  if (url == "/school/api/course/getCourseInfo") {
    delete header.Token;
  }
  return new Promise((resolve, reject) => {
    if (method === "GET") {
      axios({
        headers: header,
        method: method,
        url: baseUrl + url,
        params: data,
      })
        .then((res) => {
          if (res.data.code === 0) {
            resolve(res);
          } else {
            resolve(res);
            if (res.data.msg != "Invalid token") {
              Message.error(res.data.msg);
            }
          }
        })
        .catch((err) => {
          reject(err); //失败
        });
    } else if (method === "POST") {
      axios({
        headers: header,
        method: method,
        url: baseUrl + url,
        data: data,
      })
        .then((res) => {
          if (res.data.code === 0 || res.data.code === 90012) {
            resolve(res);
          } else if (res.data.code === 10004) {
            localStorage.removeItem(
              "user_token_" +
              localStorage.getItem(getFinalPathFromHash() + "c_id")
            );
            if (window.location.hash.split("/")[1] === "courseplay") {
              window.location.replace(
                `${window.location.origin}/#/course/${getFinalPathFromHash()}`
              );
            }
          } else if (res.data.code === 90000) {
            router.push({
              path: "/linkExpire/404",
            })
          } else if (res.data.code == 8) {
            // 清除所有缓存
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
          } else {
            if (
              res.data.msg != "" &&
              res.data.msg &&
              res.data.msg != "Invalid token" &&
              res.data.msg != "房间id错误" &&
              res.data.msg != "房间id不能为空"
            ) {
              Message.error(res.data.msg);
              reject();
            }
          }
        })
        .catch((err) => {
          reject(err); //失败
        });
    }
  });
};
export default request;
